<template>
<div class="container">
	<div v-if="!is_loading" class="columns is-vcentered">
		<div class="column is-offset-1 is-3">
			<div class="title has-text-centered">
				{{ mentee.first_name }} {{ mentee.last_name }}'s Profile
			</div>

			<button v-on:click="to_show='ProfileURL'" class="button is-primary is-fullwidth mb-3">
				ProfileURL
			</button>

			<button v-on:click="to_show='Education'" class="button is-primary is-fullwidth mb-3">
				Education
			</button>

			<button v-on:click="to_show='ResearchRequest'" class="button is-primary is-fullwidth mb-3">
				Research
			</button>

			<button v-on:click="to_show='AchievementRequest'" class="button is-primary is-fullwidth mb-3">
				Achievements
			</button>
		</div>

		<div class="column is-offset-2 is-5 px-0">
			<transition name="fade">
				<component v-bind:is="to_show" v-bind:profile_uid="$route.params.profile_uid" v-bind:list_star=" { achievements : mentorship_req['achievements'] , researches :  mentorship_req['researches']  }"  user_role="mentee" />
			</transition>
		</div>
	</div>
</div>
</template>


<script>
import ProfileURL from "../../components/common/ProfileURL";
import Education from "../../components/common/Education";
import ResearchRequest from "../../components/common/ResearchRequest";
import AchievementRequest from '../../components/common/AchievementRequest';
import axios from "../../api/my-axios";
import {mapState} from "vuex";

export default {
	components: {
		ProfileURL,
		Education,
		ResearchRequest,
		AchievementRequest,
	},
	computed: {
		...mapState({
			user: "user"
		})
	},
	data() {
		return {
			mentee: {},
			list_start : {},
			mentorship_req: {},
			is_loading: true,
			to_show: "ProfileURL",
		};
	},
	created()
	{
		if (this.user.is_mentee) {
			this.mentee = this.user;
			this.is_loading = false;
		}
		else { // Mentor is accessing
			this.get_mentee_details();
		}
	},
	methods: {
		get_mentee_details()
		{
			axios
				.get(`/api/mentee/mentee/${this.$route.params.profile_uid}/`)
				.then(response => {
					this.mentee = response.data;
					this.is_loading = false; // Important
				})
				.catch(error => {
					console.error(error);
				});
			axios
				.get(`/api/mentorship/request/${this.$route.params.mentorship_request_uid}/`)
				.then(response => {
					this.mentorship_req = response.data;
					console.log(this.mentorship_req)
				})
				.catch(error => {
					console.error(error);
				});
		}
	}
}
</script>
